// extracted by mini-css-extract-plugin
export default {"MoreTrigger":"MoreValuesTrigger_MoreTrigger__j1duA","MoreTriggerInline":"MoreValuesTrigger_MoreTriggerInline__vjw6-"};